const { q } = require('../helpers.js');

export const txtVehiclePlateNo = q('#txtVehiclePlateNo');
export const txtInsuredFirstName = q('#txtInsuredFirstName');
export const txtInsuredLastName = q('#txtInsuredLastName');
export const txtInsuredEmail = q('#txtInsuredEmail');
export const txtInsuredPhone = q('#txtInsuredPhone');
export const txtInsuredStreet = q('#txtInsuredStreet');
export const txtInsuredStreetNo = q('#txtInsuredStreetNo');
export const btnDetailsNext = q('#btnDetailsNext');
export const btnDetailsBack = q('#btnDetailsBack');